/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt, format } from '../../twd'

export default ({
    cusip,
    holdIssue='',
    holdWarningText='',
    maturity='',
    holdCoupon='',
    moodyRating='',
    spRating='',
    floaterInd='',
} = {}) => {

    return <React.Fragment>
    <div className="row"><div className="col-md-12">
        <h3>{holdIssue}</h3>
        <label
            style={{whiteSpace:'normal'}}
            dangerouslySetInnerHTML={{__html:fmt.warningText(holdWarningText)}}
        ></label>
    </div></div>

    <div className="row">
    <div className="col-md-6 col-xs-12">
        <table className="table">
        <tbody>
            <tr>
            <td>CUSIP</td>
            <td className="text-right text-bold">{cusip}</td>
            </tr>
            <tr>
            <td>Coupon</td>
            <td className="text-right text-bold">{format.cpn(holdCoupon, floaterInd)}</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div className="col-md-6 col-xs-12">
        <table className="table">
        <tbody>
        <tr>
            <td>Maturity</td>
            <td className="text-right text-bold">{maturity || '-'}</td>
            </tr>
            <tr>
            <td>Moody/S&amp;P</td>
            <td className="text-right text-bold">{moodyRating || '-'} / {spRating || '-'}</td>
            </tr>
        </tbody>
        </table>
    </div>
    </div>
    </React.Fragment>

}
